import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { 
/**
 * It's important to not mutate the original date prop.
 */
toDate as cloneDate, addDays, addMonths, addYears, format, isAfter, isBefore, isSameMonth, setMonth, setYear, } from "date-fns";
import { range } from "lodash";
import { DATE_FORMAT } from "../date-picker/date";
import { styled } from "../theme";
import { Select } from "../form/atoms/select";
import { FlexRow } from "../box";
export const YearMonthPicker = ({ date, range, tabIndex, onChange }) => {
    const start = useMemo(() => subRange(new Date(), range.before), [range.before]);
    const end = useMemo(() => addRange(new Date(), range.after), [range.after]);
    const handleMonthChange = (event) => onChange(guardDateRange(setMonth(cloneDate(date), parseInt(event.target.value, 10))), "month");
    const handleYearChange = (event) => onChange(guardDateRange(setYear(cloneDate(date), parseInt(event.target.value, 10))), "year");
    const guardDateRange = (date) => isReallyBefore(date, start) ? start : isReallyAfter(date, end) ? end : date;
    return (_jsxs(FlexRow, { children: [_jsx(InlineSelect, { tabIndex: tabIndex, name: "month", onChange: handleMonthChange, value: date?.getMonth(), "data-test-id": "yearMonthPicker-monthSelect", children: renderMonthOptions(start, end, cloneDate(date)) }), _jsx(Year, { children: _jsx(InlineSelect, { tabIndex: tabIndex, name: "year", onChange: handleYearChange, value: date?.getFullYear(), "data-test-id": "yearMonthPicker-yearSelect", children: renderYearOptions(start.getFullYear(), end.getFullYear() + 1) }) })] }));
};
YearMonthPicker.defaultProps = {
    tabIndex: 0,
};
const Year = styled.div `
  width: 80%;
`;
const InlineSelect = styled(Select) `
  font-size: 1.2em;
  padding: 6px;
  color: inherit;
  border: 1px solid transparent;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    border-color: ${({ theme }) => theme.color.fillInfo};
  }
`;
const addRange = (date, [amount, unit]) => {
    const fn = {
        year: addYears,
        month: addMonths,
        day: addDays,
    }[unit];
    return fn(date, amount);
};
const subRange = (date, [amount, unit]) => addRange(date, [-amount, unit]);
const isReallyBefore = (date, otherDate) => isBefore(date, otherDate) && isSameMonth(date, otherDate) === false;
const isReallyAfter = (date, otherDate) => isAfter(date, otherDate) && isSameMonth(date, otherDate) === false;
const renderYearOptions = (startYear, endYear) => range(startYear, endYear).map(year => (_jsx("option", { value: year, children: year }, year)));
const renderMonthOptions = (start, end, currentDate = new Date()) => range(12).map(month => {
    const then = setMonth(currentDate, month);
    return (_jsx("option", { value: month, disabled: isReallyBefore(then, start) || isReallyAfter(then, end), children: format(then, DATE_FORMAT.MONTH_NAME) }, month));
});
